import { Component, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { FieldTree, SchemaPathTree } from '@angular/forms/signals';
import { ProjectCommentsDto, ProjectCommentsDtoOptionDto } from '../../../core/mceapi.client.generated';
import { apiOptSome, getNoneOptionDto } from '../../../core/mceapi.client.helpers';
import { Option, match } from '../../../shared/functions/functional';
import { MceEditorComponent } from '../../../shared/components/mce-editor/mce-editor.component';


export interface ProjectComments {
  projectUid: string;
  dataHTML: string;
}

export function buildProjectCommentsSchema(_: SchemaPathTree<ProjectComments>) {};

export function createProjectComments(projectUid: string, comments: Option<ProjectCommentsDto>) {
  return signal<ProjectComments>({
    projectUid: projectUid,
    dataHTML: match(() => '', (x: ProjectCommentsDto) => x.dataHTML ?? '')(comments),
  });
}

export function createProjectCommentsDto(comments: FieldTree<ProjectComments>) {
  return signal<ProjectCommentsDtoOptionDto>(
    comments.dataHTML().dirty()
      ? apiOptSome({
        projectUid: comments.projectUid().value(),
        dataHTML: comments.dataHTML().value()
      })
      : getNoneOptionDto());
}

@Component({
  selector: 'project-edit-comments',
  standalone: true,
  imports: [MceEditorComponent],
  templateUrl: './project-edit-comments.component.html'
})
export class ProjectCommentsComponent {

  readonly form = input.required<FieldTree<ProjectComments>>();

}
